import appService from '../../services/appService'
import axiosInstance from '../../plugin/axios'

export const transaction = {
  namespaced: true,
  state: {
    lists: [],
    page: {},
    pagination: [],
    temp: {
      temp_id: null,
      isEditing: false
    }
  },
  getters: {
    lists: function (state) {
      return state.lists
    },

    pagination: function (state) {
      return state.pagination
    },
    page: function (state) {
      return state.page
    }
  },
  actions: {
    lists: function (context, payload) {
      return new Promise((resolve, reject) => {
        let url = 'admin/transaction'
        if (payload) {
          url = url + appService.requestHandler(payload)
        }
        axiosInstance
          .get(url)
          .then((res) => {
            if (typeof payload.vuex === 'undefined' || payload.vuex === true) {
              context.commit('lists', res.data.data)
              context.commit('page', res.data.meta)
              context.commit('pagination', res.data)
            }

            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    reset: function (context) {
      context.commit('reset')
    },

    export: function (context, payload) {
      return new Promise((resolve, reject) => {
        let url = 'admin/transaction/export'
        if (payload) {
          url = url + appService.requestHandler(payload)
        }
        axiosInstance
          .get(url, { responseType: 'blob' })
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  },
  mutations: {
    lists: function (state, payload) {
      state.lists = payload
    },
    pagination: function (state, payload) {
      state.pagination = payload
    },
    page: function (state, payload) {
      if (typeof payload !== 'undefined' && payload !== null) {
        state.page = {
          from: payload.from,
          to: payload.to,
          total: payload.total
        }
      }
    },
    reset: function (state) {
      state.temp.temp_id = null
      state.temp.isEditing = false
    }
  }
}
